import { render, staticRenderFns } from "./PasswordLinkAction.vue?vue&type=template&id=0b43cfe6&scoped=true"
import script from "./PasswordLinkAction.vue?vue&type=script&lang=js"
export * from "./PasswordLinkAction.vue?vue&type=script&lang=js"
import style0 from "./PasswordLinkAction.vue?vue&type=style&index=0&id=0b43cfe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43cfe6",
  null
  
)

export default component.exports